import { Ga4ListingType, Ga4OrderStatus, Ga4PaymentMethod, Ga4SellerType, Ga4UpgradeType } from './constants';

export const toStringOrNull = (value) => (value === null || value === undefined || value === '' ? null : String(value));

export const toNumberOrNull = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);

  return Number.isFinite(number) ? number : null;
};

export const toIntegerOrNull = (value) => {
  const number = toNumberOrNull(value);

  return number === null || !Number.isInteger(number) ? null : number;
};

export const toRoundedIntegerOrNull = (value) => {
  const number = toNumberOrNull(value);

  return number === null ? null : Math.round(number);
};

export const toBooleanOrNull = (value) => (typeof value === 'boolean' ? value : null);

export const getAccountType = (shop) => (shop ? Ga4SellerType.Shop : Ga4SellerType.Private);

export const hasDraftJsContent = (editorState) => {
  const content = editorState?.getCurrentContent?.();
  return Boolean(content && content.hasText());
};

export const getBalancePaymentMethod = (paymentMethodId, hasSelectedCard = false) => {
  const id = Number(paymentMethodId);
  if (id === 14 || (id === 2 && hasSelectedCard)) return Ga4PaymentMethod.SavedCard;
  if ([19, 20, 21].includes(id) || (id === 2 && !hasSelectedCard)) return Ga4PaymentMethod.NewCard;
  if (id === 5) return Ga4PaymentMethod.ApplePay;
  if (id === 4) return Ga4PaymentMethod.GooglePay;
  if (id === 15) return Ga4PaymentMethod.TbcMobilebank;

  return null;
};

export const getVisibilityUpgradeType = (promotionId) => {
  const id = Number(promotionId);
  if (id === 20) return Ga4UpgradeType.SuperVip;
  if (id === 15) return Ga4UpgradeType.VipPlus;
  if (id === 10) return Ga4UpgradeType.Vip;
  if (id === 1) return Ga4UpgradeType.ColorHighlight;
  if (id === 2) return Ga4UpgradeType.AutoRenewal;

  return null;
};

export const getListingType = (adTypeId) => {
  const id = Number(adTypeId);
  if (id === 0) return Ga4ListingType.Sell;
  if (id === 1) return Ga4ListingType.Buy;
  if (id === 2) return Ga4ListingType.Rent;
  if (id === 3) return Ga4ListingType.Services;
  if (id === 4) return Ga4ListingType.Auction;

  return null;
};

export const getOrderStatus = (statusId) => Ga4OrderStatus[Number(statusId)] || null;

export const getDaysActive = (createdAt, now = Date.now()) => {
  const createdTime = new Date(createdAt).getTime();
  const currentTime = new Date(now).getTime();
  if (!Number.isFinite(createdTime) || !Number.isFinite(currentTime) || currentTime < createdTime) return null;

  return Math.floor((currentTime - createdTime) / 86400000);
};

const Ga4Condition = Object.freeze({
  0: 'used',
  1: 'new',
  2: 'like_new',
  4: 'for_parts',
  5: 'outlet',
});

const Ga4VipTier = Object.freeze({
  10: 'vip',
  15: 'vip_plus',
  20: 'super_vip',
});

const getCategoryIds = (categoryTree) => {
  if (!Array.isArray(categoryTree)) return [];

  return categoryTree
    .map((category) => category?.cat_id ?? category?.CatID ?? category?.id)
    .filter((categoryId) => categoryId !== null && categoryId !== undefined && categoryId !== '')
    .map(String);
};

export const makeGa4ProductItem = (product) => {
  const categoryIds = getCategoryIds(product?.category_tree);
  const fallbackCategoryId = product?.cat_id ?? product?.catId;
  const categoryId = categoryIds[categoryIds.length - 1] ?? toStringOrNull(fallbackCategoryId);
  const vip = toNumberOrNull(product?.vip);
  const storeId = product?.shop?.shop_id ?? product?.shop?.id ?? product?.shop_id;

  return {
    item_id: toStringOrNull(product?.product_id),
    item_name: product?.lang_data?.title ?? product?.title ?? null,
    item_category: categoryIds[0] ?? null,
    item_category2: categoryIds[1] ?? null,
    item_category3: categoryIds[2] ?? null,
    item_category4: categoryIds[3] ?? null,
    item_category5: categoryIds.length >= 5 ? categoryIds.slice(4).join('/') : null,
    item_brand: product?.brand_title ?? null,
    price: toNumberOrNull(product?.price),
    quantity: 1,
    item_variant: Ga4Condition[Number(product?.cond_type_id)] ?? null,
    category_id: categoryId,
    seller_type: product?.shop || storeId ? Ga4SellerType.Shop : Ga4SellerType.Private,
    store_id: toStringOrNull(storeId),
    is_vip: vip === null ? null : vip !== 0,
    vip_tier: Ga4VipTier[vip] ?? null,
    item_attributes: null,
  };
};
